import { Sidebar } from 'v5/patterns/sidebar/Sidebar';
import { cn } from 'v5/platform/dom/cn';
import { EnterpriseMainSidebarHeaderSkeleton } from 'v5/features/core/enterprise/EnterpriseMainSidebarHeaderSkeleton';

export function EnterpriseMainSidebarLoadingShell({
  className
}: {
  className?: string;
}) {
  return (
    <Sidebar className={cn('group/sidebar', className)}>
      <EnterpriseMainSidebarHeaderSkeleton />
    </Sidebar>
  );
}
